import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import HomePage from "./Pages/HomePage/HomePage";
import ExperiencePage from "./Pages/ExperiencePage/ExperiencePage";
import ProjectsPage from "./Pages/ProjectsPage/ProjectsPage";
import ContactPage from "./Pages/ContactPage/ContactPage";
import AviationPage from "./Pages/Aviation/AviationPage";
import React from "react";
import Chat from "./Pages/Chat/Chat.tsx";
import Resume from "./Pages/ResumePage/Resume.tsx";
import IntroPage from "./Pages/IntroPage/IntroPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/experience" element={<ExperiencePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/aviation" element={<AviationPage />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/intro" element={<IntroPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
